export * from './minutes.pipe';
